<template>
  <div v-if="mapUrl">
    <div v-if="enabled">
      <iframe
        :src="mapUrl"
        class="map-iframe"
        width="360"
        height="360"
        style="border: 0"
        allowfullscreen
      ></iframe>
    </div>

    <div v-else>
      <div v-if="previewUrl" class="map-image">
        <button @click="enableMap">Klicken, um Navigation zu aktivieren</button>
        <img alt="Karte anzeigen" :src="previewUrl" />
      </div>

      <div v-else>
        <button class="btn btn-warning" @click="enableMap">
          Klicken, um Kartennavigation zu aktivieren
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    mapUrl: {
      type: String,
    },
    previewUrl: {
      type: String,
    },
  },
  data() {
    return {
      enabled: false,
    };
  },
  methods: {
    enableMap() {
      this.enabled = true;
    },
  },
};
</script>

<style scoped>
.map-image,
.map-iframe {
  display: block;
  position: relative;
}

.map-image {
  width: 360px;

  img {
    max-width: 360px;
  }

  button {
    align-items: center;
    background-color: rgba(51, 51, 51, 0.5);
    border: 0;
    color: var(--text-color);
    display: none;
    font-weight: bold;
    height: 100%;
    justify-content: center;
    position: absolute;
    width: 100%;
    z-index: 1;
  }

  &:hover button {
    display: flex;
  }
}
</style>
